export const IS_DEFINED = <T>(item: T | undefined | null): item is T => item !== undefined && item !== null;
